import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 10 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 11\" id=\"plus\">\n    <path fill=\"currentColor\" d=\"M5.5.1v4.499L10 4.6v1H5.5v4.5h-1V5.6H0v-1l4.5-.001V.1h1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol